import { Checkbox } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import React from 'react';

interface INavSectionProps {
  settings: any;
  onCheckedListChange?: (checkedList: CheckboxValueType[]) => void;
}

const NavSection: React.FunctionComponent<INavSectionProps> = ({
  settings,
  onCheckedListChange,
}) => {
  const options = settings?.options.filter((itm: any) => !itm.hide);
  const [checkedList, setCheckedList] = React.useState<CheckboxValueType[]>(
    options ? options.map((option: { value: any }) => option.value) : []
  );

  const [indeterminate, setIndeterminate] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(true);

  React.useEffect(() => {
    if (onCheckedListChange) {
      onCheckedListChange(checkedList);
    }
  }, [checkedList, onCheckedListChange]);

  const onChange = (list: CheckboxValueType[]) => {
    console.log('checkedList:', list);
    setCheckedList(list);
    setIndeterminate(Boolean(list.length) && list.length < options.length);
    setCheckAll(list.length === options.length);
  };

  const onCheckAllChange = (e: any) => {
    const allValues = options.map((option: { value: any }) => option.value);
    setCheckedList(e.target.checked ? allValues : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  return (
    <div className="course-section-body-left">
      <div className="filter">{settings?.navTitle}</div>
      <Checkbox
        indeterminate={indeterminate}
        onChange={onCheckAllChange}
        checked={checkAll}
      >
        {settings?.navSelectAll}
      </Checkbox>
      <div className="sub-filter">
        <div className="ant-checkbox-wrapper ant-checkbox-wrapper-checked default-item">
          <span className="ant-checkbox ant-checkbox-checked">
            <span className="ant-checkbox-inner" />
          </span>
          <span>{settings?.defaultItem}</span>
        </div>
        <div className="filter-item filter-item1">{settings?.filterItem1}</div>
        <div className="filter-item filter-item2">{settings?.filterItem2}</div>
        <div className="filter-item filter-item3">{settings?.filterItem3}</div>
        <Checkbox.Group
          options={options}
          value={checkedList}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default NavSection;
